
import React from "react";
import Btn from "./common/Btn";
import { i18nManager } from "../i18n";
import { IMerchItem, MERCH } from "../data";
import PageHead from "./common/PageHead";
import ProductCard from "./common/ProductCard";
import FilterTags from "./common/FilterTags";
import styles from "../assets/style.module.css";

export interface StoreProps {
    cart: IMerchItem[];
    onAddToCart: (item: IMerchItem) => void;
}

function Store({ cart, onAddToCart }: StoreProps) {

    const labels = i18nManager.Labels.store;
    const [category, setCategory] = React.useState("");
    const categories = Array.from(new Set(MERCH.map((m) => m.category)));

    return (<>
        <PageHead tag={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                <FilterTags value={category} onChange={setCategory} options={[["", labels.all], ...categories.map((c) => [c, c] as [string, string])]} />
                <div className={styles["product-grid"]}>
                    {MERCH.filter((m) => !category || m.category === category).map((item) => {
                        const added = cart.some((c) => c.id === item.id);
                        return (<ProductCard key={item.id} item={item} action={
                            <Btn size="sm" variant={added ? "outline" : "primary"} icon={added ? "fa fa-check" : "fa fa-bag-shopping"} onClick={() => onAddToCart(item)}>{added ? labels.added : labels.add_to_cart}</Btn>
                        } />);
                    })}
                </div>
            </div>
        </section>
    </>);
}

export default Store;
